// Third Party Imports
import React from 'react';
import PropTypes from 'prop-types';

// Artifactory
import {AlertDanger, AlertSuccess} from '@homeaway/react-alerts';

// Relative Imports
import './Alert.less';

class AlertBox extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        if (this.props.targetPage === 'Help page') {
            this.triggerEdapAlertView();
        }
    }

    triggerEdapAlertView() {
        this.props.appActions.triggerEdapEvent(
            'generic.event',
            {
                eventcategory: `Help page: ${this.props.type}`,
                eventaction: `Help page: ${this.props.type}`
            },
            {}
        );
    }

    hasLink(message) {
        return message.includes('</a>');
    }

    getAlertClass() {
        return this.props.size === 'sm' ? 'alert-box-sm' : 'alert-box';
    }

    render() {
        let {messageKey, translations, handleAlertDismiss, type, innerComponent} = this.props;
        const message = translations[messageKey] || messageKey;
        const clickableMessage = this.hasLink(message) ? (
            // eslint-disable-next-line react/no-danger
            <div dangerouslySetInnerHTML={{__html: message}} />
        ) : (
            <p>{message}
            {innerComponent}
            </p>
        );
        const alertClass = this.getAlertClass();

        return (
            <div className={alertClass}>
                {type === 'Alert Success' ? (
                    <AlertSuccess
                        id={'alert'}
                        dismissible
                        closeText={'Close this alert'}
                        onAlertClosed={handleAlertDismiss}
                    >
                        {clickableMessage}
                    </AlertSuccess>
                ) : (
                    <AlertDanger
                        id={'alert'}
                        dismissible
                        closeText={'Close this alert'}
                        onAlertClosed={handleAlertDismiss}
                    >
                        {clickableMessage}
                    </AlertDanger>
                )}
            </div>
        );
    }
}

AlertBox.propTypes = {
    messageKey: PropTypes.any, // eslint-disable-line react/forbid-prop-types
    translations: PropTypes.any, // eslint-disable-line react/forbid-prop-types
    handleAlertDismiss: PropTypes.func,
    type: PropTypes.string,
    innerComponent: PropTypes.any // eslint-disable-line react/forbid-prop-types

};

export default AlertBox;
